// extracted by mini-css-extract-plugin
module.exports =  {"loan-details":"_0d624b9a27--loan-details--wEGB4","text":"_0d624b9a27--text--oGjn_"};